export const TICKET_STATUS_TYPES = {
  ASSIGNED: 'Assigned',
  IN_PROGRESS: 'In Progress',
  WAITING: 'Waiting....',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
};

export const TICKET_STATUS_BADGE_STYLES = {
  Assigned: {
    backgroundColor: '#EFF8FF',
    borderColor: '#B2DDFF',
    fontColor: '#175CD3',
  },
  Completed: {
    backgroundColor: '#ECFDF3',
    borderColor: '#ABEFC6',
    fontColor: '#067647',
  },
  'In Progress': {
    backgroundColor: '#FFFAEB',
    borderColor: '#FEDF89',
    fontColor: '#B54708',
  },
  'Waiting....': {
    backgroundColor: '#FFFAEB',
    borderColor: '#FEDF89',
    fontColor: '#B54708',
  },
  Cancelled: {
    backgroundColor: '#FEF3F2',
    borderColor: '#FECDCA',
    fontColor: '#B42318',
  },
};

export const CLOSED_TICKET_STATUS = ['Completed', 'Cancelled'];
